/**
 * ToggleControl — Custom toggle switch for boolean filters (White Glass, Butt Joints).
 */
export default class ToggleControl {
  constructor(bridge, filterName, toggleSelector) {
    this.bridge = bridge;
    this.filterName = filterName;
    this.toggle = document.querySelector(toggleSelector);
    this.isActive = false;

    if (!this.toggle) {
      console.warn(`ToggleControl: toggle not found for ${filterName} (${toggleSelector})`);
      return;
    }

    this._init();

    bridge.register(filterName, {
      nativeSelector: this._getNativeSelector(),
      type: 'checkbox',
      onNativeChange: (checked) => this._onCascadeUpdate(checked)
    });
  }

  _init() {
    this.toggle.addEventListener('click', () => {
      this.isActive = !this.isActive;
      this.toggle.classList.toggle('active', this.isActive);
      this.bridge.setFilterValue(this.filterName, this.isActive);
    });
  }

  _onCascadeUpdate(checked) {
    this.isActive = !!checked;
    this.toggle.classList.toggle('active', this.isActive);
  }

  _getNativeSelector() {
    const map = {
      'white-glass': '.white-glass',
      'butt-joints': '.butt-joints',
      'absturzhemmung': '.absturzhemmung'
    };
    return map[this.filterName];
  }
}
